export const DEFAULT_TOP_N = 10;

export const SEGMENT_NAME_FILTER_OPTIONS = [{ name: 'behaviorSegmentName', label: 'Segment Name' }];

export const REACH_CHART_TITLE = 'Segment By Audience Reach %';
export const CONVERSION_CHART_TITLE = 'Segment By Audience Conversion %';
export const CONVERSION_RATE_CHART_TITLE = 'Segment By Conversion Rate';

export const MISSING_METADATA_NOTE =
  'In some cases the data for unmatched segments is too large to be pulled from AMC. In those ' +
  "cases you'll see missing values for ‘Total Users’, ‘Audience Reach %’, " +
  'and ‘Audience Conversion %’.';
